<div class="mat-typography">
  <div class="login-form">
    <div class="title">Login</div>
    <form [formGroup]="mainFormGroup">
      <div class="form-div">
        <mat-form-field
          
          class="input-class"
          [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.id)"
        >
          <mat-label>ID do cliente</mat-label>
          <input matInput type="text" placeholder="Informe o ID" formControlName="id" />
          <mat-error>
            {{ validatorErrors(mainFormGroup.controls.id) }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-div">
        <mat-form-field
          
          class="input-class"
          [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.token)"
        >
          <mat-label>Token</mat-label>
          <input matInput type="text" placeholder="Informe o token" formControlName="token" />

          <mat-error>
            {{ validatorErrors(mainFormGroup.controls.token) }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-div">
        <button type="button" mat-button (click)="loginButton()" class="main-button">Acessar</button>
      </div>
    </form>
  </div>
</div>
